import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'userFilter'
})
export class UserFilterPipe implements PipeTransform {

  transform(userListData: any, uname?: any, urole?: any,  upart?: any, ugrade?: any, uclass?: any, usubject?: any, ustatus?: any): any {

    if (uname === '' && urole === '' && upart === '' && ugrade === '' &&
       uclass === ''  && usubject === '' && ustatus === '') {
      return userListData;
    };
    return userListData.filter(function(item){
      if (uname) {
        if (uname && item.name && item.name.toLowerCase().includes(uname.toLowerCase())) {
          return item.name.toLowerCase().includes(uname.toLowerCase());
        }
        if (uname && item.first_name && item.first_name.toLowerCase().includes(uname.toLowerCase())) {
          return item.first_name.toLowerCase().includes(uname.toLowerCase());
        }
        if (uname && item.last_name && item.last_name.toLowerCase().includes(uname.toLowerCase())) {
          return item.last_name.toLowerCase().includes(uname.toLowerCase());
        }
    }

      if (urole && item.role && item.role.name && item.role.name.toLowerCase().includes(urole.toLowerCase())) {
        return item.role.name.toLowerCase().includes(urole.toLowerCase());
      }

      if (usubject && item.key_subject && item.key_subject.name && item.key_subject.name.toLowerCase().includes(usubject.toLowerCase())) {
        return item.key_subject.name.toLowerCase().includes(usubject.toLowerCase());
      }

      if (upart && item.partner && item.partner.name && item.partner.name.toLowerCase().includes(upart.toLowerCase())) {
        return item.partner.name.toLowerCase().includes(upart.toLowerCase());
      }

      if (ugrade && ugrade !== undefined && item.class && item.class.grade
        && item.class.grade.name && item.class.grade.name.toLowerCase().includes(ugrade.toLowerCase())) {
        return item.class.grade.name.toLowerCase().includes(ugrade.toLowerCase());
      }
      if (uclass && uclass !== undefined && item.class && item.class.name && item.class.name.toLowerCase().includes(uclass.toLowerCase())) {
        return item.class.name.toLowerCase().includes(uclass.toLowerCase());
      }
      if (ustatus && ustatus !== undefined) {
        if (item.active === true && ustatus === 'Active') {
          return item;
        } else if (item.active === false && ustatus === 'Archived') {
          return item;
        }
      }
    });
  }

}
